import { Routes, Route, Navigate } from "react-router-dom";

import EcomSolutions from "./EcomSolutions";

const ecomSolutionRoutes = [
  //  {routeName: 'stihealthinsurance' , component: <FinancialServices/>},
  //  {routeName: 'cvishipment' , component: <FinancialServices/>},
  //  {routeName: 'motorinsurance' , component: <FinancialServices/>},
  { routeName: "retail_cod", component: <EcomSolutions /> },
  { routeName: "warehousing", component: <EcomSolutions /> },
  { routeName: "quick-payment", component: <EcomSolutions /> },
];

const EcomSolutionRoutes = () => {
  return (
    <Routes>
      {ecomSolutionRoutes.map((route, key) => (
        <Route
          key={key}
          path={route.routeName}
          element={route.component}
        ></Route>
      ))}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default EcomSolutionRoutes;
